import axios from "axios";
import BASE_URL from "../config/api";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

// ==============================
// REQUEST
// ==============================
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ==============================
// RESPONSE
// ==============================
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    // 🔥 cek apakah request LOGIN
    const isLogin = error.config?.url?.includes("/auth/login");

    // 🔥 ambil token
    const token = localStorage.getItem("token");

    // ==========================
    // 🚫 JANGAN REDIRECT SAAT LOGIN
    // ==========================
    if (status === 401 && !isLogin && token) {
      console.warn("🔐 Token expired / unauthorized");

      // hapus session
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("role");

      // 🔥 gunakan replace (lebih aman dari reload loop)
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;